import api from 'core/api';

export const getCountries = () => api.get('countries/');
